import { useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { getOpenedTaskTags, getOpenedTaskWorkspace } from '../../../../../redux/tasks/taskEntities/selectors';
import { editTaskAction } from '../../../../../redux/tasks/actions';
import TaskTagsSection from '../TaskTagsSection';

const TaskDetailsTags = ({ taskId, taskTags, taskWorkspace }) => {
  const dispatch = useDispatch();

  const handleTagsUpdate = useCallback((tags) => {
    dispatch(editTaskAction({
      _id: taskId,
      tags: tags,
    }, null, () => {}));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  return (
    <TaskTagsSection
      updateTaskTags={handleTagsUpdate}
      tags={taskTags}
      workspace={taskWorkspace}
    />
  );
}

const mapStateToProps = (state) => ({
  taskId: getOpenedTaskId(state),
  taskTags: getOpenedTaskTags(state),
  taskWorkspace: getOpenedTaskWorkspace(state),
});

export default connect(mapStateToProps)(TaskDetailsTags);
